import React from 'react';
import { useNavigate } from 'react-router-dom';
import './index.scss';
import { LOGIN } from '../../common/routes';

const DeniedPage = () => {
    const navigate = useNavigate();

  const message = "You are already logged into another tab/browser/device - please log out to proceed here.";
  const handleRedirect = () => {
    navigate(LOGIN)
  };

  return (
    <div className='denied-page__container'>
      <div className='denied-page__message'>{message}</div>
      <div className='denied-page__backward-btn' onClick={handleRedirect}>Log in as another user</div>
    </div>)
};

export { DeniedPage }
